export function downloadFile(fileName: string, data: Blob) {
    const downloadLink = document.createElement("a");
    downloadLink.download = fileName;
    const url = URL.createObjectURL(data);
    downloadLink.href = url;
    downloadLink.click();
    URL.revokeObjectURL(url);
}

export async function downloadFileFromUrl(url: string): Promise<void> {
  try {
    const response = await fetch(url, {
      method: 'GET',
      // maybe include credentials/cors settings depending on your server
    });
    if (!response.ok) {
      throw new Error(`Download request failed. Status: ${ response.status }`);
    }

    // Get content type from response, optional
    const contentType = response.headers.get('Content-Type') || 'application/octet-stream';

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(new Blob([blob], { type: contentType }));

    const a = document.createElement('a');
    a.href = blobUrl;

    // Set the filename (including extension) via download attribute
    a.download = extractFileNameFromUrl(url);

    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error('Failed to download file:', err);
    throw err;
  }
}

export async function downloadFileFromUrlViaAnchor(url: string, fileName?: string) {
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || extractFileNameFromUrl(url);
    a.rel = 'noopener noreferrer';
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (err) {
    console.error('Download failed:', err);
  }
}

export function extractFileNameFromUrl(url: string): string {
  try {
    const u = new URL(url, window.location.href);
    const pathname = u.pathname;
    const lastSegment = pathname.substring(pathname.lastIndexOf('/') + 1);
    const cleanSegment = lastSegment || 'download';
    // optionally strip query/hash if present
    return decodeURIComponent(cleanSegment.split('?')[0].split('#')[0]);
  } catch {
    // fallback: simple parse
    const parts = url.split('/');
    const last = parts.pop() || 'download';
    return decodeURIComponent(last.split('?')[0].split('#')[0]);
  }
}

/** Quote a CSV cell when it contains a comma, quote or newline. */
export function csvCell(value: string | number | undefined | null): string {
    const text = String(value ?? "");
    return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}
